import json from "../json/userAuthorizationSubscriptions.json";

export default async () => await json;
